import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'maintenanceperiod',
    standalone: false
})
export class MaintenanceperiodPipe implements PipeTransform {
  transform(periodNumber: number, periodType: string): string {
    let result = '';

    switch (periodType) {
      case 'DAY':
        result += periodNumber > 1 ? `Elke ${periodNumber} dagen` : 'Elke dag';
        break;
      case 'WEEK':
        result += periodNumber > 1 ? `Elke ${periodNumber} weken` : 'Elke week';
        break;
      case 'MONTH':
        result +=          periodNumber > 1 ? `Elke ${periodNumber} maanden` : 'Elke maand';
        break;
      case 'YEAR':
        result += periodNumber > 1 ? `Elke ${periodNumber} jaar` : 'Elk jaar';
        break;
      default:
        result += 'onbekend';
        break;
    }

    return result;
  }
}
